import { ModelType } from './model-type.enum'

export const ApiEndpoint = {
  [ModelType.GPT3_5_Turbo]: 'https://api.openai.com/v1',
  [ModelType.GPT4_Turbo]: 'https://api.openai.com/v1',
  [ModelType.GPT4o]: 'https://api.openai.com/v1',
  [ModelType.GPT4o_Mini]: 'https://api.openai.com/v1',
  [ModelType.GPT3o_Mini]: 'https://api.openai.com/v1',
  [ModelType.Llama_Instant]: 'https://api.groq.com',
  [ModelType.Llama_Versatile]: 'https://api.groq.com',
}
